import request from '@/utils/request'


// 获取对外接口信息
export function getAjsHeaderInfo() {
    return request({
      url: '/app/ajs/getAjsHeaderInfo',
      method: 'get',
    })
  }


// 智网接口
export function getZwInfo(url, params) {
    return request({
      url: url,
      method: 'get',
      params:params
    })
  }


// WEBPACK FOOTER //
// ./src/api/open.js